module.exports = __webpack_public_path__ + "img/clock.ca1c7671.png";